import React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import Routes from './Routes';
import SwitchDeviceOffer from './components/SwitchDevice/SwitchDeviceOffer';
import UserSessionLoader from './components/UserSessionLoader';
import AxiosInterceptors from './components/AxiosInterceptors';
import { CallProvider, SelfViewProvider, TwilioUserMediaProvider } from './customer-call-sdk';
import { ToastProvider } from './context/ToastContext';
import { NotificationProvider } from './context/NotificationContext';
import { IdentityProvider } from './customer-call-sdk/context/IdentityContext';
import { useFeatureFlag } from './hooks/useFeatureFlag';
import { FEATURE_FLAG } from './config/common.constants';

const theme = createTheme({
    breakpoints: {
        values: { xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920 },
    },
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
    },
    // typography: {
    //     fontFamily: '"Source Sans Pro", sans-serif',
    // },
    palette: {
        mode: 'light',
        common: {
            black: '#000',
            white: '#fff',
        },
        background: {
            paper: '#fff',
            default: '#fafafa',
        },
        primary: {
            light: '#00aa55',
            main: '#00aa55',
            dark: '#00aa55',
            contrastText: '#fff',
        },
        secondary: {
            light: '#ff4081',
            main: '#f50057',
            dark: '#c51162',
            contrastText: '#fff',
        },
        error: {
            light: '#e57373',
            main: '#f44336',
            dark: '#d32f2f',
            contrastText: '#fff',
        },
        text: {
            primary: 'rgba(0, 0, 0, 0.87)',
            secondary: 'rgba(0, 0, 0, 0.54)',
            disabled: 'rgba(0, 0, 0, 0.38)',
        },
    },
});

const App: React.FC = () => {
    useFeatureFlag(FEATURE_FLAG.CUSTOMER_SUPPORT_ENABLED);
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <ToastProvider>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <NotificationProvider>
                            <TwilioUserMediaProvider>
                                <SelfViewProvider>
                                    <CallProvider>
                                        <IdentityProvider>
                                            <AxiosInterceptors>
                                                <UserSessionLoader>
                                                    <SwitchDeviceOffer />
                                                    <Routes />
                                                </UserSessionLoader>
                                            </AxiosInterceptors>
                                        </IdentityProvider>
                                    </CallProvider>
                                </SelfViewProvider>
                            </TwilioUserMediaProvider>
                        </NotificationProvider>
                    </LocalizationProvider>
                </ToastProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
